// extracted by mini-css-extract-plugin
export var documentation = "_l8-1";
export var menu = "_l8-0";